module.exports = __webpack_public_path__ + "img/background-curve.7c6a219f.svg";